export default {
  colors: {
    primary: '#5B1356',
    background: '#FFFFFF',
    sidebar: {
			background: '#5B1356',
			link: '#DED0DD',
			heading: '#FFFFFF',
			linkActive: '#5B1356',
			itemActive: '#DED0DD',
			footer: '#A8A8B3',
    },
    postnav: {
      background: '#5B1356',
      backgroundAlternative: '#DED0DD',
      link: '#DED0DD',
      linkAlternative: '#5B1356',
      title: '#FFFFFF',
      outline: '#4A4A49',
      backgroundActive: '#7C4278',
      linkActive: '#FFFFFF',
      outlineActive: '#FFFFFF',
    },
  },
};